export function getHistoricalDataUrl() {
    if (process.env.REACT_APP_ENVIRONMENT.startsWith("ext")) {
        let historical_data_api = "pe-history.trade.tt"
        return historical_data_api
    } else if (process.env.REACT_APP_ENVIRONMENT.startsWith("local") || process.env.REACT_APP_ENVIRONMENT.startsWith("int")) {
        let historical_data_api = "pe-history.debesys.net"
        return historical_data_api
    }
}